import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("csh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(fileId) {
  const token = localStorage.getItem("csh_token");
  return `${API}/files/${fileId}?auth=${token}`;
}

const DEFAULT_AVATAR = "https://images.unsplash.com/photo-1740252117013-4fb21771e7ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHwzZCUyMHBsYXlmdWwlMjBraWRzJTIwYXZhdGFyfGVufDB8fHx8MTc4NjM0NDU1MXww&ixlib=rb-4.1.0&q=85";
export function resolveAvatar(avatar) {
  if (!avatar) return DEFAULT_AVATAR;
  if (avatar.startsWith("http")) return avatar;
  const token = localStorage.getItem("csh_token");
  const path = avatar.startsWith("/api/") ? avatar.slice(4) : avatar;
  return `${API}${path.startsWith("/") ? "" : "/"}${path}?auth=${token}`;
}

export function ytEmbed(url) {
  if (!url) return null;
  if (url.includes("http")) {
    const m = url.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
    return url;
  }
  return `https://www.youtube.com/embed/${url}`;
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong. Please try again.";
}

export default api;
